"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchResults = exports.SearchResultsProvider = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var axios_1 = __importDefault(require("axios"));

var react_1 = __importStar(require("react"));

var DeliveryTimesRequestMapper_1 = require("../Header/Helpers/DeliveryTimesRequestMapper");

var SearchResultItemContent_v2_1 = require("./SearchResultItemContent_v2");

var util_1 = require("./../common/util"); // CONTEXT


var SearchResultsContext = react_1.default.createContext({}); // PROVIDER

var SearchResultsProvider = function SearchResultsProvider(_ref) {
  var children = _ref.children,
      results = _ref.results,
      showMoreProducts = _ref.showMoreProducts,
      isSticky = _ref.isSticky,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      itemRef = _ref.itemRef,
      storeDirectory = _ref.storeDirectory,
      isKeywordSearch = _ref.isKeywordSearch,
      setSearchText = _ref.setSearchText;

  var _ref2 = (0, frontend_e_commerce_1.useEcommerce)(),
      defaultShipToAddress = _ref2.defaultShipToAddress,
      selectedShipToAddress = _ref2.selectedShipToAddress,
      customerPickup = _ref2.customerPickup,
      salesPlant = _ref2.salesPlant;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      axiosInstance = _ref3.axiosInstance,
      zipCode = _ref3.zipCode,
      profile = _ref3.profile,
      isLoggedIn = _ref3.user.isLoggedIn,
      language = _ref3.localization.language;

  var content = SearchResultItemContent_v2_1.SearchResultItemContent_v2[language || "en"]; // PUB-SUB: Instantiated Subscribable , in this case calling it stateMessenger

  var _ref4 = (0, react_1.useState)(new frontend_common_1.Subscribable()),
      _ref5 = _slicedToArray(_ref4, 1),
      stateMessenger = _ref5[0];

  var _ref6 = (0, react_1.useState)([]),
      _ref7 = _slicedToArray(_ref6, 2),
      deliveryTimes = _ref7[0],
      setDeliveryTimes = _ref7[1];

  var _ref8 = (0, react_1.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      triggerDeliveryTimes = _ref9[0],
      setTriggerDeliveryTimes = _ref9[1];
  /* utility function for use4 inside articles and resources section
       @description returns boolean if gatsby link or not */


  var isGatsbyLinkType = function isGatsbyLinkType(isStoreLink) {
    var _a, _b;

    var isInStore = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes("/store");

    if (isStoreLink && !isInStore || !isStoreLink && isInStore) {
      return false;
    }

    return (0, util_1.isGatsbyLink)(isStoreLink, storeDirectory || "");
  };
  /* @description removes store/ from link */


  var formatArticleLink = function formatArticleLink(link) {
    var _a, _b;

    var formattedLink = link;
    var isInStore = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes("/store");
    formattedLink = isInStore ? link.replace(/store\//, "") : formattedLink;
    return formattedLink;
  };

  (0, react_1.useEffect)(function () {
    var unmounted = false;
    var cTokenSource = axios_1.default.CancelToken.source();
    var cTokenObject = {
      cancelToken: cTokenSource.token
    };

    if ((results === null || results === void 0 ? void 0 : results.matchingProducts) && (results === null || results === void 0 ? void 0 : results.matchingProducts.length) || (results === null || results === void 0 ? void 0 : results.recentlyPurchased) && (results === null || results === void 0 ? void 0 : results.recentlyPurchased.length)) {
      var allSearchResults = (results === null || results === void 0 ? void 0 : results.recentlyPurchased) && results.recentlyPurchased.length > 0 ? results === null || results === void 0 ? void 0 : results.matchingProducts.concat(results === null || results === void 0 ? void 0 : results.recentlyPurchased) : results === null || results === void 0 ? void 0 : results.matchingProducts;
      var itemsAvailabilityRequest = (0, DeliveryTimesRequestMapper_1.createItemsAvailabilityRequest)(allSearchResults || [], isLoggedIn, selectedShipToAddress ? selectedShipToAddress : defaultShipToAddress, defaultShipToAddress, customerPickup, salesPlant, zipCode, null, profile); // Delivery Times Success Handler

      var handleSuccess = function handleSuccess(response) {
        var responseData = response === null || response === void 0 ? void 0 : response.data;

        if (responseData) {
          !unmounted && setDeliveryTimes(responseData);
        } else {
          !unmounted && setDeliveryTimes([]);
        }
      }; //Error Callback


      var handleError = function handleError() {};

      (0, frontend_common_1.getDeliveryTimes)(itemsAvailabilityRequest, axiosInstance, handleSuccess, handleError, cTokenObject);
    }

    return function () {
      // cleanup api calls
      unmounted = true;
      cTokenSource.cancel("Cancelling in cleanup");
    };
  }, [results, triggerDeliveryTimes]);
  (0, react_1.useEffect)(function () {
    return function () {
      // cleanup unsubscribe to pubsub
      stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function () {
        return undefined;
      })();
    };
  }, []);
  var exposed = {
    isGatsbyLinkType: isGatsbyLinkType,
    formatArticleLink: formatArticleLink,
    isLoggedIn: isLoggedIn,
    results: results,
    showMoreProducts: showMoreProducts,
    isSticky: isSticky === undefined ? false : isSticky,
    isMobile: isMobile,
    itemRef: itemRef,
    storeDirectory: storeDirectory,
    isKeywordSearch: isKeywordSearch,
    setSearchText: setSearchText,
    deliveryTimes: deliveryTimes,
    setDeliveryTimes: setDeliveryTimes,
    setTriggerDeliveryTimes: setTriggerDeliveryTimes,
    stateMessenger: stateMessenger,
    content: content
  };
  return (0, jsx_runtime_1.jsx)(SearchResultsContext.Provider, {
    value: exposed,
    children: children
  });
};

exports.SearchResultsProvider = SearchResultsProvider;
exports.default = SearchResultsContext;

function useSearchResults() {
  return react_1.default.useContext(SearchResultsContext);
}

exports.useSearchResults = useSearchResults;